import React from "react"

type Props = {
  className?: string
}

const PeopleIcon = ({ className }: Props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M17.3271 7.93615C17.9855 8.59451 17.9855 9.66192 17.3271 10.3203C16.6688 10.9786 15.6013 10.9786 14.943 10.3203C14.2846 9.66192 14.2846 8.59451 14.943 7.93615C15.6013 7.27779 16.6688 7.27779 17.3271 7.93615"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8354 4.92729C12.8492 5.94103 12.8492 7.58462 11.8354 8.59836C10.8217 9.61209 9.17809 9.61209 8.16435 8.59836C7.15062 7.58463 7.15062 5.94103 8.16435 4.92729C9.17809 3.91356 10.8217 3.91356 11.8354 4.92729"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.05709 7.93615C5.71545 8.59451 5.71545 9.66192 5.05709 10.3203C4.39873 10.9786 3.33133 10.9786 2.67297 10.3203C2.01461 9.66192 2.01461 8.59451 2.67297 7.93615C3.33133 7.27779 4.39874 7.27779 5.05709 7.93615"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1666 15.8336V14.9202C19.1666 13.7694 18.2341 12.8369 17.0833 12.8369H16.4158"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.833252 15.8336V14.9202C0.833252 13.7694 1.76575 12.8369 2.91659 12.8369H3.58409"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4492 15.8329V14.4987C14.4492 12.8879 13.1434 11.582 11.5325 11.582H8.46672C6.85588 11.582 5.55005 12.8879 5.55005 14.4987V15.8329"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default PeopleIcon
